const EDS_BASE_ROUTE = import.meta.env.EDS_BASE_ROUTE;

const ROUTES = {
  login: EDS_BASE_ROUTE,
  register: EDS_BASE_ROUTE + "registration/:token",
  reset_password: EDS_BASE_ROUTE + "reset-password",
  delete_account: EDS_BASE_ROUTE + "delete-account",
  new_password: EDS_BASE_ROUTE + "reset-password/:token",
  password_expiration: EDS_BASE_ROUTE + "password-expiration",
  contact: EDS_BASE_ROUTE + "contact-us",
  dashboard: EDS_BASE_ROUTE + "dashboard",
  home: EDS_BASE_ROUTE + "dashboard/home",
  agenda: EDS_BASE_ROUTE + "dashboard/agenda",
  agenda_feedback: EDS_BASE_ROUTE + "dashboard/agenda/feedback",
  agenda_event: EDS_BASE_ROUTE + "dashboard/agenda/event",
  exercises: EDS_BASE_ROUTE + "dashboard/exercises",
  exercises_mock_test: EDS_BASE_ROUTE + "dashboard/exercises/book-mock-test",
  exercises_correction:
    EDS_BASE_ROUTE + "dashboard/exercises/correction/:type/:token",
  materials: EDS_BASE_ROUTE + "dashboard/materials",
  one_to_one: EDS_BASE_ROUTE + "dashboard/one-to-one",
  one_to_one_recharge: EDS_BASE_ROUTE + "dashboard/one-to-one/recharge",
  one_to_one_select_hour: EDS_BASE_ROUTE + "dashboard/one-to-one/select-hour",
  one_to_one_confirm: EDS_BASE_ROUTE + "dashboard/one-to-one/confirm",
  one_to_one_second_session:
    EDS_BASE_ROUTE + "dashboard/one-to-one/second-session",
  one_to_one_select_tutor: EDS_BASE_ROUTE + "dashboard/one-to-one/select-tutor",
  one_to_one_confirm_second_session:
    EDS_BASE_ROUTE + "dashboard/one-to-one/second-session/confirm",
  one_to_one_confirm_second_session_details:
    EDS_BASE_ROUTE + "dashboard/one-to-one/second-session/details",
  diploma_request: EDS_BASE_ROUTE + "dashboard/diploma-request",
  diploma_request_select_date:
    EDS_BASE_ROUTE + "dashboard/diploma-request/select-date",
  diploma_request_select_hour:
    EDS_BASE_ROUTE + "dashboard/diploma-request/select-hour",
  diploma_request_request_notification:
    EDS_BASE_ROUTE + "dashboard/diploma-request/request-notification",
  diploma_request_confirm: EDS_BASE_ROUTE + "dashboard/diploma-request/confirm",
  feedbacks: EDS_BASE_ROUTE + "dashboard/feedbacks",
  class_report: EDS_BASE_ROUTE + "dashboard/class-report",
  availability: EDS_BASE_ROUTE + "dashboard/availability",
  confirm_availability: EDS_BASE_ROUTE + "dashboard/availability/confirm",
  invoices: EDS_BASE_ROUTE + "dashboard/invoices",
  book_exam: EDS_BASE_ROUTE + "dashboard/book-exam",
  book_exam_details: EDS_BASE_ROUTE + "dashboard/book-exam/details/:id",
  refer_friend: EDS_BASE_ROUTE + "dashboard/refer-friend",
  impersonate: EDS_BASE_ROUTE + "impersonate/:token",
  change_event: EDS_BASE_ROUTE + "change-event/:data",
  agenda_change_event: EDS_BASE_ROUTE + "dashboard/agenda/change-event",
  access_event: EDS_BASE_ROUTE + "access/event/:base64",
  loginV3: EDS_BASE_ROUTE + "loginV3",
  resetV3: EDS_BASE_ROUTE + "reset-passwordV3",
  new_passwordv3: EDS_BASE_ROUTE + "reset-passwordV3/:token",
  new_password_successv3: EDS_BASE_ROUTE + "reset-successV3",

  // v3 routes
} as const;

export default ROUTES;
